import 'prop-types';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';
import _isEmpty from 'lodash/isEmpty';
import { isImmutable } from 'immutable';
import invariant from 'invariant';
import { Children, cloneElement } from 'react';
import '@dbh/generic-types';
import 'react-immutable-proptypes';

/**
 * Returns a function compatible with `styled.something.attrs`. Such function
 * maps `redux-form` field props, so that they are passed to the component.
 * @param {Object?} customMappingObjectParam .
 * @return {Function} Returns the mapped `props`.
 */const mapFormControlAttrsToPropsFactory=withConformsTo("mapFormControlAttrsToPropsFactory",[],a=>b=>{const c=a||{},d=Object.keys(c),{input:{name:i,value:j,onChange:k,onDragStart:l,onDrop:m,onFocus:n,onBlur:o},disabled:e,id:f,"aria-label":g,"aria-labelledby":h}=b,p={name:i,value:j,onChange:k,onDragStart:l,onDrop:m,onFocus:n,onBlur:o,disabled:e,// @see {@link https://developers.google.com/web/fundamentals/accessibility/semantics-aria/aria-labels-and-relationships}
"aria-label":g,"aria-labelledby":h,id:f};// `input` (passed by `redux-form` `Field` via `IntlFormField`) props.
return d.forEach(a=>{const d=c[a],e="function"==typeof d?d(b):d;p[a]=e;}),p});var mapFormControlAttrsToPropsFactory$1 = mapFormControlAttrsToPropsFactory;

/**
 * This is a custom React 'prop-types' validator to check that, in components
 * such as `Button` and `Text` that accept `intlFormatter` and `intlFormatterValues`
 * props, if `intlFormatterValues` is passed, `intlFormatter` must be passed too.
 * This is not executed in production, like all React 'prop-types' validators.
 * @param {Object} props .
 * @param {string} propName .
 * @param {string} componentName .
 * @return {Error} If `intlFormatter` prop is not provided with `intlFormatterValues`
 * prop.
 */const intlFormatterCheckerPropType=(a,b,c)=>{const{intlFormatterValues:d,intlFormatter:e,intlFormatterValuesFor:f}=a,g=d||f,h=g&&(isImmutable(g)?!g.isEmpty():!_isEmpty(g));return h&&!e?new Error("You have supplied the `intlFormatterValues` prop to `"+c+"`, but you also have to supply `intlFormatter` to translate."):null};var intlFormatterCheckerPropType$1 = intlFormatterCheckerPropType;

/*
 *
 * `getDisplayName`: `@dbh/react-extra`.
 *
 *//**
 * It returns the displayName of the Component passed as argument.
 * @param {React.ComponentType<*>} Component .
 * @return {string} The `displayName` of the Component.
 */const getDisplayName=a=>a.displayName||a.name||"Component";var getDisplayName$1 = getDisplayName;

/**
 * It returns the the string displayName given hocName and WrappedComponent.
 * @param {string} hocName Name of the higher order component.
 * @param {React.ComponentType<*>} WrappedComponent .
 * @return {string} The displayName of the Higher order Component.
 * @see {@link https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging}
 */const createDisplayName=withConformsTo("createDisplayName",[],(a,b)=>a+"("+getDisplayName$1(b)+")");var createDisplayName$1 = createDisplayName;

/**
 * Uses `invariant` to throw a JavaScript error message (anonymized in production).
 * @param {Error?} error If this is not a JavaScript exception, an helpful exception is thrown
 * for the developer.
 */const throwErrorInComponent=withConformsTo("throwErrorInComponent",[],a=>{invariant(!1,a.message);});var throwErrorInComponent$1 = throwErrorInComponent;

/**
 * Clones a React's component 'children' and then adds 'additionalProps' to
 * their props. Useful when a parent component has to pass a value to a child
 * and can't do it directly. If 'fnCallbackReturnsAdditionalProps' is passed,
 * 'additionalProps' is ignored because the object that the callback returns
 * is added to the cloned 'children' props. Use this technique
 * carefully (performance).
 * @param {React.ReactElement|React.ReactElement[]} children .
 * @param {Object?} additionalProps .
 * @param {Function?} fnCallbackReturnsAdditionalProps .
 */const cloneChildrenWithAdditionalProps=withConformsTo("cloneChildrenWithAdditionalProps",[],(a,b,c)=>{const d=Children.map(a,a=>{// Return if a `child` is falsy, may occur if a child is conditionally
// rendered.
if(!a)return null;const{props:d}=a,e=c?c(a):{...d,...b};return/*#__PURE__*/cloneElement(a,e)});return d});var cloneChildrenWithAdditionalProps$1 = cloneChildrenWithAdditionalProps;

const intlPropType={};var intlPropType$1 = intlPropType;

export { cloneChildrenWithAdditionalProps$1 as cloneChildrenWithAdditionalProps, createDisplayName$1 as createDisplayName, getDisplayName$1 as getDisplayName, intlFormatterCheckerPropType$1 as intlFormatterCheckerPropType, intlPropType$1 as intlPropType, mapFormControlAttrsToPropsFactory$1 as mapFormControlAttrsToPropsFactory, throwErrorInComponent$1 as throwErrorInComponent };
